// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"708":"9c6a8276","3589":"3dae5008","4558":"3dae5008","5782":"84a59b2c","9190":"137c79f6"}[chunkId] + ".chunk.css";
};